<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!custom_role_id">{{
                "Add Custom Role" | translate
              }}</v-card-title>
              <v-card-title v-if="custom_role_id">{{
                "Edit Custom Role" | translate
              }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                            >{{ k }} {{ v }}</v-alert
                          >
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Custom Role name' | translate"
                            v-model="custom_role_name"
                            name="custom_role_name"
                            autocomplete="off"
                            :rules="customrolenameRules"
                            required
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                        <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="permission_labels"
                            item-value="permission_label_id"
                            :item-text="item =>$t(item.permission_label+'-key')"
                            name="permission_labels"
                            :items="permissionLabels"
                            :label="'Permission Labels' | translate"
                            @change="permissionLabelUpdated()"
                            outlined
                            autocomplete="off"
                            chips
                            multiple
                            small-chips
                            :no-data-text="$t('No data available')"
                          >
                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                            v-model="selectedpermissions"
                            :items="allpermissions"
                            item-value="permission_id"
                            :item-text="item =>$t(item.permission_name+'-key')"
                            :label="'Select Permission' | translate"
                            outlined
                            chips
                            multiple
                            small-chips
                            :no-data-text="$t('No data available')"
                          >

                            <template #message="{ message }">
                              {{
                                curLanguage.lang_code == "en"
                                  ? message
                                  : $t(message)
                              }}
                            </template>

                            <template v-slot:item="{ item }">
                              <div class="d-flex flex-column"> 
                                <b>{{$t(item.permission_name+'-key')}}</b>
                                <span class="font-weight-light">{{$t(item.permission_name+'-val')}}</span>
                              </div>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>

                    </v-col>
                    <v-col cols="12" sm="4" md="4">

                    </v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="custom_role_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="custom_role_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-overlay :value="showLoader">
        <v-layout row justify-center v-if="showLoader">
          <v-dialog
            v-model="showLoader"
            persistent
            fullscreen
            content-class="loading-dialog"
          >
            <v-container fill-height>
              <v-layout row justify-center align-center>
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-layout>
      </v-overlay>
    </v-container>
  </v-content>
</template>

<script>
import {
  FETCH_PERMISSION_LABELS,
  FETCH_PERMISSIONS,
  ADD_CUSTOM_ROLE,
  RESET_STATE,
  UPDATE_CUSTOM_ROLE,
  FETCH_INDIVIDUAL_CUSTOM_ROLE
} from "@/store/actions.type";
import {
  SET_SNACKBAR,
  SET_LOADING,
  SET_ROUTER_ENTER,
} from "@/store/mutations.type";
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "addeditQuiz",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
      Promise.all([
      store.dispatch(RESET_STATE),
      store.dispatch(FETCH_PERMISSIONS, ""),
      store.dispatch(FETCH_PERMISSION_LABELS, ""),
    ]).then(() => {
      store.commit(SET_LOADING, false);
      store.commit(SET_ROUTER_ENTER, false);
    });
    
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_CUSTOM_ROLE, to.params.id).then((resp) => {
        if (resp.success) {
          store.commit(SET_LOADING, false);
          store.commit(SET_ROUTER_ENTER, false);
        }
      });
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "curLanguage",
      "permissionLabels",
      "allpermissions",
      "individualcrole",
    ]),
    ...mapState({
      errors: (state) => state.customrole.croleerrors,
      curLanguage: (state) => state.translations.curLanguage,
    }),
    footertext() {
      return this.$t("Rows per page");
    },
    customrolenameRules() {
      return [(v) => !!v || "Custom Role Name is required"];
    },
  },
  created() {
    //allow route permissions
  },
  mounted() {
    let company_meta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = company_meta.primary_color;
    if(Object.keys(this.individualcrole).length > 0){
      this.custom_role_id = this.individualcrole.custom_role_id
      this.custom_role_name = this.individualcrole.custom_role_name
      this.selectedpermissions = this.individualcrole.permissions
      this.permission_labels = this.individualcrole.permission_labels
      this.permissionLabelUpdated();
    }

  },
  data: function () {
    return {
      custom_role_id: null,
      custom_role_name: null,
      selectedpermissions: [],
      status: null,
      show: false,
      showLoader: false,
      permission_labels: null,
    };
  },
  methods: {
    async permissionLabelUpdated() {
      await store
        .dispatch(FETCH_PERMISSIONS, "?permission_label_ids=" + this.permission_labels)
        .then((resp) => {
          this.permissions = resp.data;
          //remove any selected permissions if label is not present
          const newselcted = [];
            this.selectedpermissions.forEach((item) => {
            if(this.permissions.find((x) => x.permission_id === item)!=undefined){
              newselcted.push(this.permissions.find((x) => x.permission_id === item).permission_id)
            }
            this.selectedpermissions = newselcted;
          });
        });
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(ADD_CUSTOM_ROLE, {
            custom_role_name: this.custom_role_name,
            permissions: this.selectedpermissions,
            permission_labels: this.permission_labels,
          }).then((resp) => {
          if (
            resp != undefined &&
            resp.hasOwnProperty("success") &&
            resp.success
          ) {
            store.commit(SET_LOADING, false);
            store.commit(SET_SNACKBAR, {
              status: true,
              message: "Custom Role created successfully",
            });
            this.$router.push({ name: "customrole" });
          } else {
            store.commit(SET_LOADING, false);
          }
        });
      }
    },
    update: function () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch(UPDATE_CUSTOM_ROLE, {
            custom_role_id: this.custom_role_id,
            custom_role_name: this.custom_role_name,
            permissions: this.selectedpermissions,
            permission_labels: this.permission_labels,
            _method: "put"
          }).then((resp) => {
          if (
            resp != undefined &&
            resp.hasOwnProperty("success") &&
            resp.success
          ) {
            store.commit(SET_LOADING, false);
            store.commit(SET_SNACKBAR, {
              status: true,
              message: "Custo Role updated successfully",
            });
            this.$router.push({ name: "customrole" });
          } else {
            store.commit(SET_LOADING, false);
          }
        });
      }
    },
  },
};
</script>
